/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindAuctionCatalogsResponseDto } from '../../models/find-auction-catalogs-response-dto';

export interface FindAuctionCatalogs$Params {
  auctionId: number;
  'X-API-Version'?: string;
}

export function findAuctionCatalogs(http: HttpClient, rootUrl: string, params: FindAuctionCatalogs$Params, context?: HttpContext): Observable<StrictHttpResponse<FindAuctionCatalogsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, findAuctionCatalogs.PATH, 'get');
  if (params) {
    rb.query('auctionId', params.auctionId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindAuctionCatalogsResponseDto>;
    })
  );
}

findAuctionCatalogs.PATH = '/api/auction-catalogs';
